import { render, staticRenderFns } from "./InstagramLogo.vue?vue&type=template&id=15f1e650&scoped=true"
var script = {}
import style0 from "./InstagramLogo.vue?vue&type=style&index=0&id=15f1e650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f1e650",
  null
  
)

export default component.exports